/**
 * IMAGE-VIEWER.JS
 */

import 'lightgallery.js';
import 'lightgallery.js/dist/css/lightgallery.css';

export default function InitImageViewer() {
	const lightGalleries = document.querySelectorAll('.image-viewer');
	if (lightGalleries.length === 0) return;

	lightGalleries.forEach((gallery) => {
		lightGallery(gallery, {
			selector: '.image',
		});
	});
}